import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ChangeOperationType } from '../enums/ChangeOperationType';
import { ChangeType } from '../enums/ChangeType';
import { EditDataList, IEditDataList } from '../models/DTOs/IEditDataList';
import { IEnvelopeInDTO } from '../models/DTOs/IEnvelopeInDTO';
import { IEnvelopeOutDTO } from '../models/DTOs/IEnvelopeOutDTO';
import { IKitchenVideoDTO } from '../models/DTOs/IKitchenVideoDTO';
import { IKitchenVideo } from '../models/IKitchenVideo';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class KitchenVideosService {
  private KitchenVideoSetupEndPoint = environment.APIEndpoint +  'frontend/corporation/{corporationId}/site/{siteId}/KitchenVideos';

  constructor(private loginService: LoginService, private http: HttpClient) { }

  GetKitchenVideos(CorporationID: string, SiteID: string): Observable<IKitchenVideo[]> {
    const Token: string = this.loginService.AccessToken.authToken;
    if (Token !== '') {
      const endPoint: string = this.KitchenVideoSetupEndPoint.replace('{corporationId}', CorporationID).replace('{siteId}', SiteID);

      return this.http.get(endPoint, { headers: new HttpHeaders().set('Authorization', 'Bearer ' + Token), observe: 'response' }).pipe(
        map((data: HttpResponse<IKitchenVideoDTO[]>) => {
          
          if (data.ok) {
            return this.formatData(data.body);
          }

        }), 
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
    }
  }

  private formatData(dataList: IKitchenVideoDTO[]): IKitchenVideo[] {
    let list: IKitchenVideo[] = [];

    // convert list
    dataList.forEach(item => {
      list.push({
        id: item.id,
        kitchenVideoGuid: item.kitchenVideoGuid,
        kitchenVideoDeviceId: item.kitchenVideoDeviceId,
        kitchenVideoName: item.kitchenVideoName,
        screenId: item.screenId,
        ipAddress: item.ipAddress,
        isSelected: false,
        changeState: ChangeType.None
      });
    });

    // sort data
    list = this.sortData(list);

    return list;
  }

  private sortData(list: IKitchenVideo[]): IKitchenVideo[] {
    return list.sort((Item1: IKitchenVideo, Item2: IKitchenVideo) => {
      if (Item1.screenId > Item2.screenId) {
        return 1;
      }

      if (Item1.screenId < Item2.screenId) {
        return -1;
      }
    });
  }

  SaveKitchenVideos(CorporationID: string, SiteID: string, oldData: IKitchenVideo[], newData: IKitchenVideo[]): Observable<IKitchenVideo[]> {
    const Token: string = this.loginService.AccessToken.authToken;
    if (Token !== '') {
      const endPoint: string = this.KitchenVideoSetupEndPoint.replace('{corporationId}', CorporationID).replace('{siteId}', SiteID);

      const data: IEditDataList<IKitchenVideoDTO> = this.SplitItems(newData);

      return this.http.post(endPoint, data, { headers: new HttpHeaders().set('Authorization', 'Bearer ' + Token), observe: 'response' }).pipe(
        map((data: HttpResponse<IKitchenVideoDTO[]>) => {
          
          if (data.ok) {
            return this.formatData(data.body);
          }

        }), 
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
    }
  }

  private DeflateItems(list: IKitchenVideo[]): IKitchenVideoDTO[] {
    const newData: IKitchenVideoDTO[] = [];

    if (list != null) {
      list.forEach(item => {
        newData.push({
          id: item.id,
          kitchenVideoGuid: item.kitchenVideoGuid,
          kitchenVideoDeviceId: item.kitchenVideoDeviceId,
          kitchenVideoName: item.kitchenVideoName,
          screenId: item.screenId,
          ipAddress: item.ipAddress,
        });
      });
    }

    return newData;
  }

  private SplitItems(data: IKitchenVideo[]): IEditDataList<IKitchenVideoDTO> {
    let newData: IEditDataList<IKitchenVideoDTO> = new EditDataList<IKitchenVideoDTO>();

    newData.newItems = this.DeflateItems(data.filter(i => i.changeState === ChangeType.New));
    newData.editItems = this.DeflateItems(data.filter(i => i.changeState === ChangeType.Edited));
    newData.deleteItems = this.DeflateItems(data.filter(i => i.changeState === ChangeType.Deleted));

    return newData;
  }
}
